//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Product',
  data: function data() {
    return {};
  },
  methods: {
    goInfo: function goInfo() {
      this.$router.push({
        name: "Infos"
      });
    },
    login: function login() {
      window.open('https://llhsh.zhelihao123.com/admin/');
    }
  }
};